import { InjectionToken } from '@angular/core';
import { CheckoutCardConfig } from '../models/checkout-card/checkout-card-config.type';

export const CHECKOUT_CARD_CONFIG = new InjectionToken<CheckoutCardConfig>(
  'Checkout card config'
);
